// Castintech dashboard — Sidebar arama kutusu (F4-B+ 2026-05-26).
//
// AMAÇ: 40 view + 62 sidebar item arasında kullanıcı "fatura" yazınca eşleşmeyen
// item'lar gizlenir, eşleşmeyen grup (içinde eşleşme yoksa) tamamen kollapse edilir.
// Diakritik ve büyük/küçük harf duyarsız — Türkçe karakter normalizasyonu.
//
// Tasarım:
// - Input #sb-search-input → her keystroke filtre uygula
// - Filter regex: input.toLocaleLowerCase('tr-TR') diakritik strip + indexOf
// - Eşleşen sb-item visible kalır, eşleşmeyen display:none
// - Eşleşen item içeren grup açık (details[open]=true), tamamen eşleşmeyen grup kapalı + hidden
// - Boş arama: tüm görünürlük restore + originalOpen state korunur

import { $ } from '../utils.js';

let _bound = false;
const _origOpenState = new WeakMap<HTMLDetailsElement, boolean>();

// Türkçe karakter normalize (büyük/küçük + diakritik strip)
function normalize(s: string): string {
  return s
    .toLocaleLowerCase('tr-TR')
    .replace(/[ıİ]/g, 'i')
    .replace(/[şŞ]/g, 's')
    .replace(/[ğĞ]/g, 'g')
    .replace(/[üÜ]/g, 'u')
    .replace(/[öÖ]/g, 'o')
    .replace(/[çÇ]/g, 'c');
}

function applyFilter(query: string): void {
  const q = normalize(query.trim());
  const isEmpty = q.length === 0;

  const groups = document.querySelectorAll<HTMLDetailsElement>('.sb-group');
  for (const group of Array.from(groups)) {
    // Original open state capture (ilk filter çağrısında)
    if (!_origOpenState.has(group)) {
      _origOpenState.set(group, group.open);
    }

    const items = group.querySelectorAll<HTMLElement>('.sb-item');
    let groupHasMatch = false;

    for (const item of Array.from(items)) {
      // sb-item text (sb-icon + label + sb-badge) — sadece label görmek için clone
      const text = normalize(item.textContent || '');
      const match = isEmpty || text.includes(q);
      item.style.display = match ? '' : 'none';
      if (match) groupHasMatch = true;
    }

    // Group visibility
    if (isEmpty) {
      // Boş arama → tüm gruplar visible, original open state restore
      group.style.display = '';
      group.open = _origOpenState.get(group) ?? false;
    } else {
      group.style.display = groupHasMatch ? '' : 'none';
      group.open = groupHasMatch;  // Eşleşme varsa otomatik aç
    }
  }
}

export function bindSidebarSearch(): void {
  if (_bound) return;
  // F4-B+ defensive: test ortamında JSDOM cleanup sonrası document/window kaybolur,
  // async chain (guardAuth.then -> bindSidebarSearch) tetiklenirse undefined.
  if (typeof document === 'undefined' || typeof window === 'undefined') return;
  const input = $('sb-search-input') as HTMLInputElement | null;
  if (!input) return;
  _bound = true;

  let debounceTimer: number | null = null;
  input.addEventListener('input', () => {
    if (debounceTimer !== null) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(() => {
      applyFilter(input.value);
    }, 80);
  });

  // ESC → temizle
  input.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      input.value = '';
      applyFilter('');
      input.blur();
    }
  });
}
